export default {
    VMS_SITE_LIST: '站点列表',
    VMS_SITE_CREATE: "新建站点",
    VMS_SITE_CREATE_SUCCESS: "新站点创建成功",
    VMS_SITE_MODIFY: "修改站点",
    VMS_SITE_MODIFY_SUCCESS: "站点修改成功",
    VMS_SITE_CODE: '编号',
    VMS_SITE_CODE_REQUIRED: '请输入编号',
    VMS_SITE_NAME: '名称',
    VMS_SITE_NAME_REQUIRED: '请输入名称',
    VMS_SITE_SEQUENCE: '排序',
    VMS_SITE_MSG_HAVE_CHILDREN: '站点存在位置，请先删除位置！',
    VMS_SITE_DATA_GROUP: '数据组',

    VMS_LOCATION_LIST: '位置列表',
    VMS_LOCATION_CREATE: "新建位置",
    VMS_LOCATION_CREATE_SUCCESS: "新位置创建成功",
    VMS_LOCATION_MODIFY: "修改位置",
    VMS_LOCATION_MODIFY_SUCCESS: "位置修改成功",
    VMS_LOCATION_SITE: '所属站点',
    VMS_LOCATION_SITE_REQUIRED: '请选择位置',
    VMS_LOCATION_CODE: '编号',
    VMS_LOCATION_CODE_REQUIRED: '请输入编号',
    VMS_LOCATION_NAME: '名称',
    VMS_LOCATION_NAME_REQUIRED: '请输入名称',
    VMS_LOCATION_SEQUENCE: '排序',
    VMS_LOCATION_MSG_HAVE_CHILDREN: '位置存在场所，请先删除场所！',

    VMS_AREA_LIST: '场所列表',
    VMS_AREA_CREATE: "新建场所",
    VMS_AREA_CREATE_SUCCESS: "新场所创建成功",
    VMS_AREA_MODIFY: "修改场所",
    VMS_AREA_MODIFY_SUCCESS: "场所修改成功",
    VMS_AREA_LOCATION: '所属位置',
    VMS_AREA_LOCATION_REQUIRED: '请选择场所',
    VMS_AREA_CODE: '编号',
    VMS_AREA_CODE_REQUIRED: '请输入编号',
    VMS_AREA_NAME: '名称',
    VMS_AREA_NAME_REQUIRED: '请输入名称',
    VMS_AREA_TYPE: '类型',
    VMS_AREA_TYPE_REQUIRED: '请输入类型',
    VMS_AREA_SEQUENCE: '排序',
    VMS_AREA_TYPE_NORMAL: "普通",
    VMS_AREA_TYPE_SPECIAL: "特殊",

    VMS_VISITOR_TYPE: '访客类型',
    VMS_VISITOR_TYPE_CREATE: '添加访客类型',
    VMS_VISITOR_TYPE_CREATE_SUCCESS: '访客类型添加成功',
    VMS_VISITOR_TYPE_MODIFY: '修改访客类型',
    VMS_VISITOR_TYPE_MODIFY_SUCCESS: '访客类型修改成功',
    VMS_VISITOR_TYPE_CODE: '编号',
    VMS_VISITOR_TYPE_CODE_REQUIRED: '请输入编号',
    VMS_VISITOR_TYPE_NAME: '名称',
    VMS_VISITOR_TYPE_NAME_REQUIRED: '请输入名称',
    VMS_VISITOR_TYPE_VALUE: '值',
    VMS_VISITOR_TYPE_VALUE_REQUIRED: '请输入值',
    VMS_VISITOR_TYPE_SEQUENCE: '排序',
    VMS_VISITOR_TYPE_WORKFLOW_FORM: '审批流表单',

    VMS_VISIT_REQUEST_UPDATE_SUCCESS: "访问信息更新成功",
    VMS_VISIT_REQUEST_NUMBER: '申请编号',
    VMS_VISIT_REQUEST_APPLY_DATE: '申请日期',
    VMS_VISIT_REQUEST_STATUS: '申请状态',
    VMS_VISIT_REQUEST_STATUS_NEW: '新申请',
    VMS_VISIT_REQUEST_STATUS_APPROVING: '审批中',
    VMS_VISIT_REQUEST_STATUS_APPROVED: '审批通过',
    VMS_VISIT_REQUEST_STATUS_REJECTED: '审批拒绝',
    VMS_VISIT_REQUEST_STATUS_EXPIRED: '审批过期',
    VMS_VISIT_REQUEST_STATUS_COMPLETED: '完成',
    VMS_VISIT_REQUEST_STATUS_CANCELED: '取消',

    VMS_VISIT_REQUEST_GENERAL_INFO: '基本信息',
    VMS_VISIT_REQUEST_VISITOR_INFO: '访客信息',
    VMS_VISIT_REQUEST_HOST_INFO: '联系人信息',
    VMS_VISIT_REQUEST_CONFIRM_INFO: '确认信息',
    VMS_VISIT_REQUEST_REGISTER_COMPLETE: '登记完成',
    VMS_VISIT_REQUEST_PLACE: '访问场所',
    VMS_VISIT_REQUEST_PLACE_SELECT: '选择访问场所',
    VMS_VISIT_REQUEST_PLACES_REQUIRED: '请选择访问场所',
    VMS_VISIT_REQUEST_VISITORS_REQUIRED: '请填写访客信息',
    VMS_VISIT_REQUEST_ARRIVE_DATE: '访问日期',
    VMS_VISIT_REQUEST_ARRIVE_TIME: '入场时间',
    VMS_VISIT_REQUEST_ARRIVE_TIME_SELECT: '选择入场时间',
    VMS_VISIT_REQUEST_ARRIVE_TIME_REQUIRED: '请填写入场时间',
    VMS_VISIT_REQUEST_SITE: '访问大楼',
    VMS_VISIT_REQUEST_ARRIVE_START_DATE: '访问开始日期',
    VMS_VISIT_REQUEST_ARRIVE_START_TIME: "开始时间",
    VMS_VISIT_REQUEST_ARRIVE_END_DATE: '访问结束日期',
    VMS_VISIT_REQUEST_ARRIVE_END_TIME: "结束时间",
    VMS_VISIT_REQUEST_PURPOSE_TYPE: '访问目的',
    VMS_VISIT_REQUEST_EMPLOYEE_ENTITY: '接待者所属公司',

    VMS_VISIT_REQUEST_PURPOSE: '访问理由',
    VMS_VISIT_REQUEST_PURPOSE_LOADING: '装货',
    VMS_VISIT_REQUEST_PURPOSE_DISCHARGE: '卸货',
    VMS_VISIT_REQUEST_PURPOSE_REQUIRED: "请填写访问理由",
    VMS_VISIT_REQUEST_INVITE_SUCCESS: '访客邀请创建成功',
    VMS_VISIT_REQUEST_REGISTER_SUCCESS: '访客登记成功',
    VMS_VISIT_REQUEST_WITHDRAW_SUCCESS: '取消预约成功',
    VMS_VISIT_REQUEST_HOST_SELECT: '选择接待者',
    VMS_VISIT_REQUEST_VISITOR_SELECT: '选择访客',
    VMS_VISIT_REQUEST_VISITOR_COUNT: '访客数',


    VMS_VISIT_REQUEST_APPLY_SOURCE_TYPE: '申请来源',
    VMS_VISIT_REQUEST_APPLY_SOURCE_TYPE_EMPLOYEE_WEB: '内部员工网页邀请',
    VMS_VISIT_REQUEST_APPLY_SOURCE_TYPE_EMPLOYEE_APPLET: '内部员工小程序',
    VMS_VISIT_REQUEST_APPLY_SOURCE_TYPE_MANAGER_WEB: '管理员网页登记',
    VMS_VISIT_REQUEST_APPLY_SOURCE_TYPE_VISITOR_APPLET: '访客小程序申请',
    VMS_VISIT_REQUEST_APPLY_SOURCE_TYPE_VISITOR_MOBILE_WEB: "访客移动端页面",

    VMS_VISIT_REQUEST_HOST_MOBILE: '接待者手机号',
    VMS_VISIT_REQUEST_HOST_MOBILE_SEARCH: '填写接待者手机号并查询',
    VMS_VISIT_REQUEST_HOST_NAME_SEARCH: '填写接待者姓名点右边放大镜查询',

    VMS_VISIT_REQUEST_HOST_STAFF_NUMBER: '接待者员工号',
    VMS_VISIT_REQUEST_HOST_STAFF_NUMBER_REQUIRED: '请填写接待者员工号',
    VMS_VISIT_REQUEST_HOST_MOBILE_REQUIRED: '请填写接待者手机号',
    VMS_VISIT_REQUEST_HOST_EMAIL: '接待者邮箱',
    VMS_VISIT_REQUEST_HOST_EMAIL_REQUIRED: '请填写接待者邮箱',
    VMS_VISIT_REQUEST_HOST_NAME: '接待者姓名',
    VMS_VISIT_REQUEST_DEPARTMENT:'接待者部门',
    VMS_VISIT_REQUEST_HOST_LAST_NAME: '接待者姓氏',
    VMS_VISIT_REQUEST_HOST_LAST_NAME_REQUIRED: '请填写接待者姓氏',
    VMS_VISIT_REQUEST_HOST_FIRST_NAME: '接待者名字',
    VMS_VISIT_REQUEST_HOST_FIRST_NAME_REQUIRED: '请填写接待者名字',
    VMS_VISIT_REQUEST_HOST_LAST_INFO_RELOAD: '接待者信息加载',
    VMS_VISIT_REQUEST_HOST_LAST_INFO_RELOAD_SUCCESS: '接待者信息加载成功',
    VMS_VISIT_REQUEST_HOST_LAST_INFO_RELOAD_CONFIRM: '该接待者存在历史记录，是否需要加载最近一次该接待者的信息?',
    VMS_VISIT_REQUEST_HOST_SUPERVISOR_NAME: '接待者上级姓名',
    VMS_VISIT_REQUEST_HOST_SUPERVISOR_EMAIL: '接待者上级邮箱',
    VMS_VISIT_REQUEST_HOST_DEPARTMENT_NAME: '接待者部门',
    VMS_VISIT_REQUEST_HOST_DEPARTMENT_NAME_REQUIRED: '请填写接待者部门',
    VMS_VISIT_REQUEST_HOST_NAME_REQUIRED: '请填写接待者姓名',
    VMS_VISIT_REQUEST_HOST_NOT_FOUND: '未检索到接待者',
    VMS_VISIT_REQUEST_REGISTER_SUBMIT_SUCCESS: '访客登记提交成功',
    VMS_VISIT_REQUEST_REGISTER_ANOTHER_ONE: '登记下一位',
    VMS_VISIT_REQUEST_REGISTER_STEP_HOST_INFO: '接待者信息',
    VMS_VISIT_REQUEST_REGISTER_STEP_HOST_INFO_ALERT: '接待者信息填写过一次后，可通过员工号进行查询自动填入',
    VMS_VISIT_REQUEST_REGISTER_STEP_VISITOR_INFO: '访客信息',
    VMS_VISIT_REQUEST_REGISTER_STEP_VISITOR_INFO_ALERT: '访客信息填过一次后，可通过手机号进行查询自动填入',
    VMS_VISIT_REQUEST_REGISTER_STEP_VISITOR_VEHICLE: '访客车辆',
    VMS_VISIT_REQUEST_REGISTER_STEP_CONFIRM_INFO: '确认信息',
    VMS_VISIT_REQUEST_REGISTER_STEP_CONSENT_LETTER: '同意书',
    VMS_VISIT_REQUEST_REGISTER_STEP_COMPLETE: '登记完成',
    VMS_VISIT_REQUEST_REGISTER_STEP_TRAINING: '培训测试',
    VMS_VISIT_REQUEST_REGISTER_STEP_SUBMIT: '提交',
    VMS_VISIT_REQUEST_DETAIL: '访问申请详细',
    VMS_VISIT_REQUEST_PENDING_APPROVAL_LIST: '待审批列表',
    VMS_VISIT_REQUEST_CLASSIFY: '分类',
    VMS_VISIT_REQUEST_CLASSIFY_NONE: '未分类',
    VMS_VISIT_REQUEST_CLASSIFY_VISITOR: '访客',
    VMS_VISIT_REQUEST_CLASSIFY_CONSTRUCTION: '施工',
    VMS_VISIT_REQUEST_CLASSIFY_SHIPPING: '装卸货',
    VMS_VISIT_REQUEST_CLASSIFY_SPECIAL_VEHICLE: '特殊车辆',
    VMS_VISIT_REQUEST_CLASSIFY_EMPLOYEE_VEHICLE: '员工车辆',
    VMS_VISIT_REQUEST_APPLICANT_INFO: '申请者信息',
    VMS_VISIT_REQUEST_APPLICANT_STAFF_NUMBER: '申请者工号',
    VMS_VISIT_REQUEST_APPLICANT_NAME: '申请者姓名',
    VMS_VISIT_REQUEST_EMPLOYEE_VEHICLE_SUBMIT_SUCCESS: '员工车辆申请提交成功.',
    VMS_VISIT_REQUEST_DUPLICATE_APPOINTMENTS_NOT_ALLOWED: "同一有效期内已有未完成的访问预约，不能重复申请",

    // 携带货品和运输物品
    VMS_VISIT_REQUEST_TRANSPORT_GOODS: "运输物品",
    VMS_VISIT_REQUEST_PERSONAL_GOODS_FLAG: "是否携带私人物品",
    VMS_VISIT_REQUEST_PERSONAL_GOODS_DESCRIPTION: "私人物品描述",

    // 第二接待者
    VMS_VISIT_REQUEST_HOST_2ND: "接待者2",
    VMS_VISIT_REQUEST_HOST_NAME_2ND: "接待者2姓名",
    VMS_VISIT_REQUEST_HOST_MOBILE_2ND: "接待者2手机号",
    VMS_VISIT_REQUEST_HOST_DEPARTMENT_2ND: "接待者2部门",

    VMS_REQUEST_VISITOR_REGISTER: '访客登记',
    VMS_REQUEST_VISITOR_REGISTER_INFO_FILL: '访客信息补充',

    VMS_REQUEST_VISITOR_REGISTER_DESC: '登记访客的基本信息及联系人基本信息，完成访客登记',
    VMS_REQUEST_VISITOR_CHECKIN: "来访人员签到",
    VMS_REQUEST_VISITOR_CHECKIN_TIME: '签到时间',
    VMS_REQUEST_VISITOR_CHECKIN_SUCCESSFUL: '签到成功，请等待接待人员确认',
    VMS_REQUEST_VISITOR_CHECKIN_SUCCESSFUL_AUTO_CLOSE: '{seconds}s后自动关闭该签到窗口',
    VMS_REQUEST_VISITOR_CHECKIN_LOADING: '签到数据提交中',
    VMS_REQUEST_VISITOR_CHECKOUT: '签出',
    VMS_REQUEST_VISITOR_CHECKOUT_TIME: '签出时间',
    VMS_REQUEST_VISITOR_CHECKOUT_READER: '签出口',
    VMS_REQUEST_VISITOR_CHECKOUT_DESC: '访客离开时，通过身份证或者卡号，完成签出确认',
    VMS_REQUEST_VISITOR_CHECKOUT_SUCCESS: '访客签出成功',
    VMS_REQUEST_VISITOR_CHECKOUT_CONFIRM: '确认要签出并归还卡吗？',
    VMS_REQUEST_VISITOR_CHECKOUT_CARD_NUMBER_DIFFERENT: '已绑的卡跟本次输入的卡不一致，确定要用该卡号签出吗？',
    VMS_REQUEST_VISITOR_SEARCH: '查询当日访客',
    VMS_REQUEST_VISITOR_SEARCH_PLACEHOLDER: '请输入/扫描访客的证件号码或者门禁卡号',
    VMS_REQUEST_VISITOR_CONFIRM_INFO: '访客信息确认',
    VMS_REQUEST_VISITOR_CHECKOUT_COMPLETE: '签出完成',
    VMS_REQUEST_VISITOR_CHECKOUT_ANOTHER_ONE: '签出下一位',
    VMS_REQUEST_VISITOR_NOT_FOUND: '未查询到访客信息',
    VMS_REQUEST_VISITOR_ACCESS_IN: "签入",
    VMS_REQUEST_VISITOR_ACCESS_IN_TIME: '签入时间',
    VMS_REQUEST_VISITOR_ACCESS_IN_READER: '签入口',
    VMS_REQUEST_VISITOR_ACCESS_OUT: '签离',
    VMS_REQUEST_VISITOR_ACCESS_OUT_TIME: '签离时间',
    VMS_REQUEST_VISITOR_ACCESS_OUT_READER: "签离口",

    VMS_REQUEST_VISITOR_MANAGEMENT: '访客管理',
    VMS_REQUEST_VISITOR_MANAGEMENT_DESC: '管理访客的名单，显示访客的身份信息和接待者信息',

    VMS_REQUEST_VISITOR_INFO: '访客信息',
    VMS_REQUEST_VISITOR_LIST: '人员列表',
    VMS_REQUEST_VISITOR_DETAIL: '访客详细',
    VMS_REQUEST_VISITOR_CREATE: '创建人员信息',
    VMS_REQUEST_VISITOR_MODIFY: '修改人员信息',
    VMS_REQUEST_VISITOR_GENERAL_INFO: '访客信息',
    VMS_REQUEST_VISITOR_VISIT_REQUEST_INFO: '访问信息',

    VMS_REQUEST_VISITOR_VEHICLE_INFO: '司机车辆信息',
    VMS_REQUEST_VISITOR_ARRIVE_DATE: '访问日期',
    VMS_REQUEST_VISITOR_ARRIVE_START_DATE_REQUIRED: '请选择访问开始日期',
    VMS_REQUEST_VISITOR_ARRIVE_END_DATE_REQUIRED: '请选择访问结束日期',
    VMS_REQUEST_VISITOR_VISIT_CODE: "访客码",
    VMS_REQUEST_VISITOR_VISIT_CODE_REQUIRED: "请输入访客码",
    VMS_REQUEST_VISITOR_VISIT_CODE_VERIFY: "验证访客码",
    VMS_REQUEST_VISITOR_VISIT_CODE_INVALID: "该访客码无效，请确认是否是当日的有效访客码。",
    VMS_REQUEST_VISITOR_VISIT_CODE_TIMEOUT: "该访客码已超时，请重新刷新获取最新访客码。",
    VMS_REQUEST_VISITOR_VISIT_CODE_QRCODE: "二维码",

    VMS_REQUEST_VISITOR_NAME: '访客姓名',
    VMS_REQUEST_VISITOR_NAME_REQUIRED: '请填写访客姓名',
    VMS_REQUEST_VISITOR_LAST_NAME: '访客姓',
    VMS_REQUEST_VISITOR_LAST_NAME_REQUIRED: '请填写访客姓氏',
    VMS_REQUEST_VISITOR_FIRST_NAME: '访客名',
    VMS_REQUEST_VISITOR_FIRST_NAME_REQUIRED: '请填写访客名字',
    VMS_REQUEST_VISITOR_MOBILE: '访客手机号',
    VMS_REQUEST_VISITOR_MOBILE_REQUIRED: '请填写访客手机号',
    VMS_REQUEST_VISITOR_MOBILE_FORMAT_ERROR: '请填写格式正确的手机号',
    VMS_REQUEST_VISITOR_EMAIL: '访客邮箱',
    VMS_REQUEST_VISITOR_EMAIL_REQUIRED: '请填写访客邮箱',
    VMS_REQUEST_VISITOR_EMAIL_FORMAT_ERROR: "请填写格式正确的邮箱地址",
    VMS_REQUEST_VISITOR_EMAIL_TIPS: "请填写联系邮箱，相关访问通知会发到该邮箱",
    VMS_REQUEST_VISITOR_COMPANY: '访客公司',
    VMS_REQUEST_VISITOR_COMPANY_REQUIRED: '请填写访客公司',
    VMS_REQUEST_VISITOR_ID_TYPE: '证件类型',
    VMS_REQUEST_VISITOR_ID_NUMBER: '证件号码',
    VMS_REQUEST_VISITOR_EMPLOYEE_NO: '员工编号',
    VMS_REQUEST_VISITOR_ID_TYPE_REQUIRED: '请填写证件类型',
    VMS_REQUEST_VISITOR_EMPLOYEE_NO_REQUIRED: '请填写员工编号',
    VMS_VISITOR_MSG_ID_NUMBER_FORMAT_ERROR: "请填写格式正确的身份证",

    VMS_REQUEST_VISITOR_ID_NUMBER_REQUIRED: '请填写证件号码',
    VMS_REQUEST_VISITOR_TYPE: '访客类型',
    VMS_REQUEST_VISITOR_JOB: '职业',
    VMS_REQUEST_VISITOR_DRIVE_TYPE: '驾驶类型',
    VMS_REQUEST_VISITOR_DRIVE_TYPE_NONE: '无',
    VMS_REQUEST_VISITOR_DRIVE_TYPE_DRIVER: '驾驶',
    VMS_REQUEST_VISITOR_DRIVE_TYPE_PASSENGER: '搭乘',
    VMS_REQUEST_VISITOR_PLATE_NUMBER: '车牌号码',
    VMS_REQUEST_VISITOR_PLATE_NUMBER_REQUIRED: '请填写车牌号码',
    VMS_REQUEST_VISITOR_PLATE_NUMBER_COLOR: '号牌颜色',
    VMS_REQUEST_VISITOR_PLATE_NUMBER_COLOR_REQUIRED: '请填写号牌颜色',
    VMS_REQUEST_VISITOR_PLATE_NUMBER_COLOR_BLUE: "蓝牌",
    VMS_REQUEST_VISITOR_PLATE_NUMBER_COLOR_YELLOW: "黄牌",
    VMS_REQUEST_VISITOR_PLATE_NUMBER_COLOR_WHITE: "白牌",
    VMS_REQUEST_VISITOR_PLATE_NUMBER_COLOR_BLACK: "黑牌",
    VMS_REQUEST_VISITOR_PLATE_NUMBER_COLOR_GREEN: "新能源绿牌",
    VMS_REQUEST_VISITOR_PLATE_NUMBER_COLOR_OTHER: "其他",
    VMS_REQUEST_VISITOR_VEHICLE_USE_TYPE: '使用性质',
    VMS_REQUEST_VISITOR_VEHICLE_TYPE: '车辆类型',
    VMS_REQUEST_VISITOR_VEHICLE_TYPE_REQUIRED: '请填写车辆类型',
    VMS_REQUEST_VISITOR_VEHICLE_TYPE_CAR: "小型汽车",
    VMS_REQUEST_VISITOR_VEHICLE_TYPE_TRUCK: "大型货车",
    VMS_REQUEST_VISITOR_VEHICLE_TYPE_MOTORCYCLE: "摩托车",
    VMS_REQUEST_VISITOR_VEHICLE_TYPE_BUS: "客车",
    VMS_REQUEST_VISITOR_VEHICLE_TYPE_SPECIAL: "特种车辆",
    VMS_REQUEST_VISITOR_VEHICLE_TYPE_OTHER: "其他",
    VMS_REQUEST_VISITOR_VEHICLE_REGISTRATION_DATE: "注册登记日",
    VMS_REQUEST_VISITOR_VEHICLE_REGISTRATION_DATE_REQUIRED: "请填写注册登记日",
    VMS_REQUEST_VISITOR_VEHICLE_FUEL_TYPE: "燃料类型",
    VMS_REQUEST_VISITOR_VEHICLE_FUEL_TYPE_REQUIRED: "请填写燃料类型",
    VMS_REQUEST_VISITOR_VEHICLE_FUEL_TYPE_GAS: "汽油",
    VMS_REQUEST_VISITOR_VEHICLE_FUEL_TYPE_DIESEL: "柴油",
    VMS_REQUEST_VISITOR_VEHICLE_FUEL_TYPE_NATURAL_GAS: "天然气",
    VMS_REQUEST_VISITOR_VEHICLE_FUEL_TYPE_ELECTRIC: "电力",
    VMS_REQUEST_VISITOR_VEHICLE_FUEL_TYPE_OTHER: "其他",
    VMS_REQUEST_VISITOR_VEHICLE_EMISSION_STANDARD: "排放标准",
    VMS_REQUEST_VISITOR_VEHICLE_EMISSION_STANDARD_REQUIRED: "请填写排放标准",
    VMS_REQUEST_VISITOR_VEHICLE_EMISSION_STANDARD_NATIONAL_III: "国三",
    VMS_REQUEST_VISITOR_VEHICLE_EMISSION_STANDARD_NATIONAL_IV: "国四",
    VMS_REQUEST_VISITOR_VEHICLE_EMISSION_STANDARD_NATIONAL_V: "国五",
    VMS_REQUEST_VISITOR_VEHICLE_EMISSION_STANDARD_NATIONAL_VI: "国六",
    VMS_REQUEST_VISITOR_VEHICLE_EMISSION_STANDARD_NATIONAL_ELECTRIC: "电动",
    VMS_REQUEST_VISITOR_ACCESS_INFO: '通行信息',
    VMS_REQUEST_VISITOR_ACCESS_CARD_NUMBER: '门禁卡号',
    VMS_REQUEST_VISITOR_ACCESS_CARD_NUMBER_PLACEHOLDER: '请输入门禁卡号',
    VMS_REQUEST_VISITOR_ACCESS_CARD_NUMBER_BIND: '绑卡',
    VMS_REQUEST_VISITOR_ACCESS_CARD_NUMBER_BIND_SUCCESS: '访客卡绑定成功，已完成签入',
    VMS_REQUEST_VISITOR_LAST_INFO_RELOAD: '访客信息加载',
    VMS_REQUEST_VISITOR_LAST_INFO_RELOAD_SUCCESS: '访客信息加载成功',
    VMS_REQUEST_VISITOR_LAST_INFO_RELOAD_CONFIRM: '该访客存在历史记录，是否需要加载最近一次该访客的信息?',
    VMS_REQUEST_VISITOR_EMPLOYEE_EMAIL: "被访者邮箱",
    VMS_REQUEST_VISITOR_QUICK_SELECT: '历史访客快速选择',
    VMS_REQUEST_VISITOR_CONSTRUCTION_ORDER_NUMBER: '施工单号',
    VMS_REQUEST_VISITOR_STATUS: '访客状态',
    VMS_REQUEST_VISITOR_STATUS_VISIT_WAITING: '待审批',
    VMS_REQUEST_VISITOR_STATUS_CHECK_IN_PENDING: "待签到",
    VMS_REQUEST_VISITOR_STATUS_CHECK_IN: "已签入",
    VMS_REQUEST_VISITOR_STATUS_CHECK_OUT: "已签出",
    VMS_REQUEST_VISITOR_STATUS_CHECK_IN_REJECT: "已拒绝",
    VMS_REQUEST_VISITOR_STATUS_EXPIRED: "过期",
    VMS_REQUEST_VISITOR_STATUS_CANCEL: "取消",

    VMS_REQUEST_VISITOR_HISTORY_LIST: "历史访客",
    VMS_VISITOR_ID_TYPE_ID: "身份证",
    VMS_VISITOR_ID_TYPE_PASSPORT: "护照",

    VMS_VISITOR_REQUEST_HISTORY: "预 约 历 史",

    // 驾驶人信息
    VMS_REQUEST_VISITOR_DRIVER_NAME: '驾驶人姓名',
    VMS_REQUEST_VISITOR_DRIVER_LAST_NAME: '驾驶人姓',
    VMS_REQUEST_VISITOR_DRIVER_LAST_NAME_REQUIRED: '请填写驾驶人姓氏',
    VMS_REQUEST_VISITOR_DRIVER_FIRST_NAME: '驾驶人名',
    VMS_REQUEST_VISITOR_DRIVER_FIRST_NAME_REQUIRED: '请填写驾驶人名字',
    VMS_REQUEST_VISITOR_DRIVER_MOBILE: '驾驶人手机号',
    VMS_REQUEST_VISITOR_DRIVER_MOBILE_REQUIRED: '请填写驾驶人手机号',
    VMS_REQUEST_VISITOR_DRIVER_ID_NUMBER: '驾驶人身份证号码',
    VMS_REQUEST_VISITOR_DRIVER_ID_NUMBER_REQUIRED: '请填写驾驶人身份证号码',
    VMS_REQUEST_VISITOR_DRIVER_COMPANY: '驾驶人公司',
    VMS_REQUEST_VISITOR_DRIVER_COMPANY_REQUIRED: '请填写驾驶人公司',
    VMS_REQUEST_VISITOR_SPECIAL_VEHICLE_CERTIFICATE_UPLOAD: '特种证件拍照上传',
    VMS_REQUEST_VISITOR_SPECIAL_VEHICLE_CERTIFICATE_UPLOAD_REQUIRED: '请上传特种证件拍照',
    VMS_REQUEST_VISITOR_DRIVER_LICENSE_UPLOAD: '驾驶证上传',
    VMS_REQUEST_VISITOR_DRIVER_LICENSE_UPLOAD_REQUIRED: '请上传驾驶证',
    VMS_REQUEST_VISITOR_VEHICLE_LICENSE_UPLOAD: '行驶证上传',
    VMS_REQUEST_VISITOR_VEHICLE_LICENSE_UPLOAD_REQUIRED: '请上传行驶证',
    VMS_REQUEST_VISITOR_PHOTO: '照片',
    VMS_REQUEST_VISITOR_PHOTO_CAPTURE_TIPS: '请拍摄照片用于人脸通行授权认证',
    VMS_REQUEST_VISITOR_PHOTO_VERIFY_FAILED: '人脸照片验证失败，请重新拍摄',
    VMS_REQUEST_VISITOR_PHOTO_DOWNLOAD: '照片下载',
    VMS_REQUEST_VISITOR_CONSTRUCTION_ORDER_UPLOAD: '施工单上传',
    VMS_REQUEST_VISITOR_CONSTRUCTION_CAPTURE_TIPS: '请手持施工单对准摄像头拍照',
    VMS_REQUEST_VISITOR_SPECIAL_VEHICLE_CAPTURE_TIPS: '请手持特殊车辆证件对准摄像头拍照',
    VMS_REQUEST_VISITOR_ATTACH_FILE: '附件列表',
    VMS_REQUEST_VISITOR_ATTACH_FILE_DOWNLOAD: '附件下载',
    VMS_REQUEST_VISITOR_ATTACH_FILE_NAME: '附件名',
    VMS_REQUEST_VISITOR_ATTACH_FILE_CLASSIFY: '附件分类',
    VMS_REQUEST_VISITOR_ATTACH_FILE_CLASSIFY_SPECIAL_VEHICLE: '特种车辆证件',
    VMS_REQUEST_VISITOR_ATTACH_FILE_CLASSIFY_DRIVER_LICENSE: '驾驶证',
    VMS_REQUEST_VISITOR_ATTACH_FILE_CLASSIFY_VEHICLE_LICENSE: '车辆行驶证',
    VMS_REQUEST_VISITOR_ATTACH_FILE_CLASSIFY_CONSTRUCTION_ORDER: '施工单',
    VMS_REQUEST_VISITOR_ATTACH_FILE_CLASSIFY_QUALIFICATION_CERTIFICATE: '从业资格证',
    VMS_REQUEST_VISITOR_ATTACH_FILE_CLASSIFY_ROAD_OPERATION_LICENSE: '道路经营许可证',
    VMS_REQUEST_VISITOR_ATTACH_FILE_CLASSIFY_VEHICLE_SIDE_PHOTO: '车身侧面全景照片',
    VMS_REQUEST_VISITOR_ZK_ADD_PERSON_FAILED: "添加车牌失败，人员编号与车牌号不匹配",
    VMS_REQUEST_VISITOR_TRAINING_NON_ANSWER: "请回答题目",
    VMS_REQUEST_VISITOR_TRAINING_SCORE_REQUIRED: "未达到最低分要求，请确认这些题目",
    VMS_REQUEST_VISITOR_TRAINING_SKIP: "培训记录在12个月内有效，跳过本次培训测评",

    // 访问场所
    VMS_REQUEST_PLACE_LIST: "访问场所列表",
    VMS_REQUEST_PLACE_AREA_NAME: "场所名",
    VMS_REQUEST_PLACE_AREA_CODE: "场所编号",
    VMS_REQUEST_PLACE_AREA_MANAGER_NAME: "管理员姓名",
    VMS_REQUEST_PLACE_AREA_MANAGER_EMAIL: "管理员邮箱",

    // 访客访问记录
    VMS_VISITOR_ACCESS_LOG_ACCESS_DATE: '通行日期',
    VMS_VISITOR_ACCESS_LOG_ACCESS_TIME: '通行时间',
    VMS_VISITOR_ACCESS_LOG_ACCESS_READER: '通行读卡器',
    VMS_VISITOR_ACCESS_LOG_ACCESS_CARD_NUMBER: '通行卡号',
    VMS_VISITOR_ACCESS_LOG_ACCESS_DIRECTION: '通行方向',
    VMS_VISITOR_ACCESS_LOG_ACCESS_DIRECTION_CHECKIN: '签入',
    VMS_VISITOR_ACCESS_LOG_ACCESS_DIRECTION_CHECKOUT: '签出',
    VMS_VISITOR_ACCESS_LOG_LIST: "访客进出记录",
    VMS_VISITOR_ACCESS_LOG_LIST_FETCH: "获取访客进出记录",
    VMS_VISITOR_BTN_WITHDRAW: "取消预约",

    // 访客卡管理
    VMS_CARD_BUTTON_SHOW_FAILED_ONLY: "仅显示失败",
    VMS_CARD_SEND_CARD: "分配通行卡",
    VMS_CARD_IMPORT: "访客卡批量导入",
    VMS_CARD_NUMBER: "访客卡编号",
    VMS_CARD_STATUS: "访客卡状态",
    VMS_CARD_STATUS_AVAILABLE: "可用",
    VMS_CARD_STATUS_BINDING: "使用中",
    VMS_CARD_CLASSIFY: "卡分类",
    VMS_CARD_CLASSIFY_PERSON: "人卡",
    VMS_CARD_CLASSIFY_VEHICLE: "车卡",
    VMS_CARD_TERMINAL: "终端",
    VMS_CARD_NUMBER_DUPLICATE: "卡编号重复",
    VMS_CARD_NUMBER_REQUIRED: "卡编号是必填项",
    VMS_CARD_STATUS_REQUIRED: "卡状态是必填项",
    VMS_CARD_CLASSIFY_REQUIRED: "卡分类是必填项",
    VMS_CARD_AVAILABLE_CARD_NO_FOUND: "未找到有效访客卡",
    VMS_CARD_SEND_CARD_NOTICE: "请分配以下卡号给访客，如需重新获取卡号，请点击刷新按钮",
    VMS_CARD_SEND_CARD_FAILED: "分配卡号失败，请联系管理员确认卡池数据是否正确。",

    // 访客黑名单管理
    VMS_VISITOR_BLACK_LIST_ADD: "添加访客黑名单",
    VMS_VISITOR_BLACK_LIST_ADD_SUCCESS: "添加访客黑名单成功。",
    VMS_VISITOR_BLACK_LIST_MODIFY: "更新访客黑名单",
    VMS_VISITOR_BLACK_LIST_MODIFY_SUCCESS: "更新访客黑名单成功。",
    VMS_VISITOR_BLACK_LIST: "访客黑名单列表",
    VMS_VISITOR_FIRST_NAME: "名字",
    VMS_VISITOR_FIRST_NAME_REQUIRED: "名字是必填项",
    VMS_VISITOR_LAST_NAME: "姓氏",
    VMS_VISITOR_LAST_NAME_REQUIRED: "姓氏是必填项",
    VMS_VISITOR_NAME: "姓名",
    VMS_VISITOR_EMAIL: "邮箱",
    VMS_VISITOR_MOBILE: "手机号",
    VMS_VISITOR_PHOTO: "照片",
    VMS_VISITOR_COMPANY: "公司",
    VMS_VISITOR_ID_TYPE: "证件类型",
    VMS_VISITOR_ID_NUMBER: "证件号码",
    VMS_VISITOR_ID_NUMBER_REQUIRED: '请填写访客证件号码',
    VMS_VISITOR_BLACK_LIST_REGISTERED_WARNING: '该访客登记在黑名单中，确认要继续登记吗？',
    VMS_VISITOR_CARD_NUMBER_USED_WARNING: '该卡号还没有签出，请选择其他卡号。',

    // v自助终端管理
    VMS_TERMINAL_DEVICE_LIST: "设备列表",
    VMS_TERMINAL_CODE: "编号",
    VMS_TERMINAL_NAME: "名称",
    VMS_TERMINAL_CODE_REQUIRED: "编号是必填项",
    VMS_TERMINAL_CODE_DUPLICATE: "编号重复",
    VMS_TERMINAL_WELCOME_TITLE: "欢迎莅临雅保",
    VMS_TERMINAL_WELCOME_SIGN_IN_ZH: "持 访 客 码 签 到",
    VMS_TERMINAL_WELCOME_SIGN_IN_EN: "Visit Code Check In",
    VMS_TERMINAL_WELCOME_REGISTER_ZH: "现 场 预 约 登 记",
    VMS_TERMINAL_WELCOME_REGISTER_EN: "On Site Registration",
    VMS_TERMINAL_WELCOME_SIGN_IN_SCAN_HELP: "请出示入场二维码，对准机器扫码口，快捷签到",
    VMS_TERMINAL_STEP_VISIT_INFO: "访问信息",
    VMS_TERMINAL_STEP_ID_NUMBER: "身份证",

    VMS_TERMINAL_STEP_CONSTRUCTION_ORDER: "施工单",
    VMS_TERMINAL_STEP_SPECIAL_VEHICLE_LICENSE: "特种证件",
    VMS_TERMINAL_STEP_PORTRAIT: "头像",
    VMS_TERMINAL_STEP_ACCESS_CODE: "通行码",
    VMS_TERMINAL_STEP_ACCESS_CODE_DESCRIPTION: "请打印或拍下通行码，凭码通行",
    VMS_TERMINAL_STEP_FINISH: "完成",
    VMS_TERMINAL_STEP_VEHICLE_ENVIRONMENTAL: "车辆环保信息",

    VMS_VISITOR_BTN_CHECKOUT: "签出",
    VMS_VISITOR_MSG_CHECKOUT_CONFIRM: "访客签出，请确认",
    EXOS_ACCESS_RIGHT_MSG_ASSIGN_FAILED: "Exos权限设定失败，请联系系统管理员",
    EXOS_BADGE_MSG_NOT_FOUND: "找不到该卡号，请确认",
    EXOS_ACCESS_RIGHT_MSG_BADGE_PERSON_NOT_FOUND: "门禁卡无效，请确认",

    // 访问申请时间设定
    VMS_REQUEST_TIME_SETTING_DISABLE: '不可选',
    VMS_REQUEST_TIME_SETTING_ENABLE: '可选',
    VMS_REQUEST_TIME_SETTING_FULL: '已约满',

    // 移动端
    VMS_MOBILE_WELCOME_EMPLOYEE_REGISTER:"雅保员工预约",
    VMS_MOBILE_WELCOME_SELF_REGISTER: "外部访客预约",
    VMS_MOBILE_WELCOME_SELF_EMPLOYEE_ENTRANCE: "员 工 入 口",
};
